<template>
  <div class="article-member-panel">
    <div class="article-member-tag">参与人</div>

    <div class="member-list">
      <div class="member-items-wrapper">
        <div
          class="member-item"
          :title="`${member.deptName} : ${member.name}`"
          v-for="(member, index) of members"
          :key="index"
        >
          <div
            class="member-avatar"
            :style="`background-image: url(${avatarPre}/${member.avatar})`"
          ></div>
          <div class="member-name">
            {{ member.name }}
          </div>
        </div>

        <!--用于占位使用-->
        <div
          class="member-item"
          v-if="members.length !== 0"
          style="height: 0;margin-top: 0;margin-bottom: 0"
          v-for="i of 20"
        ></div>
      </div>

      <div class="member-empty" v-if="members.length === 0">
        <span
          class="empty-data-image"
          style="background-image: url('static/images/empty_data.png')"
        ></span>
        没有选择参与人
      </div>
    </div>
  </div>
</template>

<script>
import { generateStandardSpan } from "@/utils/acquireStandardSpan";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";

export default {
  name: "ArticleMemberInvite",
  props: {
    //参与人
    participant: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  filters: {
    filterCount(item, that) {
      let obj = {};
      obj.count = 0;
      that.recursionCount(item.children, obj);
      return obj.count;
    }
  },
  data() {
    return {
      that: this,
      members: [],
      memberSpan: 4,
      discuss: {
        users: [],
        attachments: []
      },
      avatarPre: window.config.avatar.baseUrl,
      memberSensitive: 80
    };
  },

  mounted() {
    this.initData();
  },

  watch: {
    members(newVal) {
      this.$emit("update:participant", newVal);
    },

    participant(newVal) {
      this.members = newVal;
    },

    keyword(newVal) {
      this.searchConditionChange();
    },

    "discuss.users": {
      deep: true,
      handler(newVal) {
        for (let item of newVal) {
          if (item.checked) {
            //查询是否有这个数据
            let data = this.members.find(ev => {
              return ev.userId === item.userId;
            });
            if (this.members.length === 0 || !data) {
              this.members.push(item);
            }
          } else {
            //取消选中将选中的数据移除
            for (let i = 0; i < this.members.length; i++) {
              let member = this.members[i];
              if (member.userId === item.userId) {
                this.members.splice(i, 1);
              }
            }
          }
        }
      }
    }
  },

  methods: {
    recursionCount(items, obj) {
      for (let item of items) {
        if (item.isMember) {
          obj.count++;
        } else {
          this.recursionCount(item.children, obj);
        }
      }
    },

    //清空数据
    clearMemberInviteInfo() {
      this.members = this.$options.data().members;
      this.discuss = this.$options.data().discuss;
    },

    //清空搜索条件
    clearSearchCondition() {
      this.keyword = this.$options.data().keyword;
    },

    //如果修改,则查询参与人信息
    initData() {},

    //移除成员
    handleRemoveMember(item) {
      //移除members中的数据
      this.members.splice(this.members.indexOf(item), 1);

      //移除users中的选中状态
      for (let user of this.discuss.users) {
        if (user.userId === item.userId) {
          user.checked = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.article-member-panel {
  flex: 1;
  height: 0;
  display: flex;
  flex-direction: column;
  .article-member-tag {
    display: flex;
    justify-content: center;
    height: 22px;
    line-height: 20px;
    font-size: 16px;
    color: #888888;
  }
  .member-list {
    margin: 10px;
    width: 100%;
    flex: 1;
    overflow: auto;
    .member-items-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: flex-start;
      .member-item {
        cursor: pointer;
        width: 50px;
        margin: 2px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .member-avatar {
          width: 45px;
          height: 45px;
          background-size: cover;
          border: #e8e6e6 2px solid;
          border-radius: 8px;
          align-self: center;
        }
        .member-name {
          width: 50px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;
        }
      }
    }
    .member-empty {
      height: 100%;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #bababa;
      .empty-data-image {
        display: inline-block;
        width: 100px;
        height: 100px;
        background-size: cover;
      }
    }
  }
}

/*   >>>深度选择器*/
.item-checkbox >>> .el-checkbox__inner {
  margin: 23px 0;
}

/*   >>>深度选择器*/
.item-checkbox >>> .el-checkbox__input {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/article/ArticleMemberInvite.vue